import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import LoadingPage from '@/common/pages/LoadingPage';
import { getAdjusterOpinionQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/getAdjusterOpinion/getAdjusterOpinionQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="نظر کارشناسی" header="titleHeader">
      <ShowAdjusterOpinion />
    </MainLayout>
  );
};
const ShowAdjusterOpinion = () => {
  const { id } = useParams();

  const { isPending: getAdjusterOpinionLoading, data } = useQuery(
    getAdjusterOpinionQueryOptions({
      id: id!,
    }),
  );

  if (getAdjusterOpinionLoading) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1.5rem">
      <ShowIncidentParticipantsDataCard
        data={[
          { label: 'شرح حادثه', value: data?.adjuster_opinion },
          { label: 'نظر کارشناسی', value: data?.accident_description },
        ]}
        title=""
      />
    </Box>
  );
};
